import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseQueryOptions, useQuery } from 'react-query'
import { ChannelInsight } from 'types'

interface Props {
  externalIntegrationId?: number
}

type Data = ChannelInsight[]

export const fetchFn = async ({
  externalIntegrationId,
  workspaceId,
}: {
  externalIntegrationId?: number
  workspaceId: number
}) => {
  const res = await sendToApi<{ insights: ChannelInsight[] }>(
    `/w/${workspaceId}/external_integrations/${externalIntegrationId}/insights`,
  )
  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }
  return res.data.insights
}

export const useInsights = ({ externalIntegrationId }: Props, options?: UseQueryOptions<Data>) => {
  const workspaceId = useCurrentWorkspaceId()
  const queryKey = ['workspaces', workspaceId, 'externalIntegrations', externalIntegrationId, 'channelInsights']

  return useQuery<Data>(queryKey, () => fetchFn({ externalIntegrationId, workspaceId }), {
    refetchOnWindowFocus: false,
    enabled: !!externalIntegrationId,
    ...options,
  })
}
